import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CaseService } from 'src/app/services/case.service';
import { ContactFormPage } from '../contact-form/contact-form.page';
import { AccountDetailsPage } from '../account-details/account-details.page';
import { IonNav, ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationPreferencesComponent } from '../account-details/communication-preferences/communication-preferences.component';

@Component({
  selector: 'app-personal-detail',
  templateUrl: './personal-detail.page.html',
  styleUrls: ['./personal-detail.page.scss'],
})
export class PersonalDetailPage implements OnInit {
  debtorDetailsSubscription: Subscription;
  debtorDetails;
  caseDetailsSubscription: Subscription;
  datepicker_date_format = 'DD/MM/YYYY';
  firstCaseId;
  fieldLabels: any = {};
  showBackButton = false;
  emails = [];
  emailItems = [];
  phoneItems = [];
  addEmail = false;
  addPhone = false;
  newEmail = '';
  isNewEmail = true;
  newPhone = '';
  isNewPhone = true;
  debtorEmail = '';
  isEmail = false;
  isSMS = false;
  debtorId = null;

  lateralClients = {
    lackfords: 'Lackfords',
  };
  currentClientName;
  constructor(
    private caseService: CaseService,
    private ionNav: IonNav,
    private authService: AuthService,
    private translate: TranslateService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    var hostname = window.location.hostname;
    var url_split = hostname.split('.');
    this.currentClientName = this.lateralClients[url_split[0]]
      ? this.lateralClients[url_split[0]]
      : 'Us';

    this.checkNavigationContext();

    this.getDebtorDetails();
    this.getCaseDetails();
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (portalSettings?.fieldLabels) {
      this.fieldLabels = portalSettings.fieldLabels;
    }
  }

  checkNavigationContext() {
    this.ionNav.canGoBack().then((canGoBack) => {
      this.showBackButton = canGoBack;
    }).catch(() => {
      this.showBackButton = false;
    });
  }

  ionViewWillEnter() {
    this.checkNavigationContext();
  }

  formatDate(inputDateString) {
    let settings = JSON.parse(localStorage.getItem('portal_settings'));
    if (settings?.datepicker_date_format) {
      this.datepicker_date_format = settings.datepicker_date_format;
    }
    const inputDate = moment(inputDateString);
    const formattedDate = inputDate.format(this.datepicker_date_format);
    return formattedDate;
  }
  getCaseDetails() {
    this.caseDetailsSubscription = this.caseService
      .getCaseDetailsData()
      .subscribe((res: any) => {
        if (res.result) {
          const caseList = Object.values(res.data.caseList);
          this.firstCaseId = caseList[0]?.['id'];
        }
      });
  }
  async goToContactFormUpdate() {
    this.ionNav.push(ContactFormPage, {
      caseId: this.firstCaseId,
      placeholder: this.translate.instant('CONTACT_FORM.PLACEHOLDER'),
      textLabel: this.translate.instant('CONTACT_FORM.TEXT_LABEL'),
      formName: 'personal'
    });
  }
  async goToContactForm() {
    this.ionNav.push(ContactFormPage, { caseId: this.firstCaseId, formName: 'contact' });
  }
  getDebtorDetails() {
    this.debtorDetailsSubscription = this.authService
      .getdebtorDetailsData()
      .subscribe((res: any) => {
        if (res && res.result) {
          this.debtorDetails = res.data;

          this.debtorId = res.data.debtor_id;
          this.emails = res.data.emails;
          this.emailItems = this.emails.map((ele) => {
            if (!parseInt(ele.doNotSendEmail)) {
              return {
                type: 'email',
                id: ele.id,
                email: ele.account,
                sendEmail: !parseInt(ele.doNotSendEmail),
              }
            }
            return undefined;
          }).filter((ele) => ele !== undefined);

          this.emailItems.forEach((element) => {
            if (element.sendEmail) {
              this.isEmail = true;
            }
          });
          this.phoneItems = res.data.phone_numbers.map((ele) => {
            if (!!parseInt(ele.isActive)) {
              return {
                type: 'telephone',
                id: ele.id,
                number: ele.number,
                isActive: !!parseInt(ele.isActive),
              }
            }
            return undefined;
          }).filter((ele) => ele !== undefined);

          this.phoneItems.forEach((element) => {
            if (element.isActive) {
              this.isSMS = true;
            }
          });
          if (res.data.debtor_email) {
            this.debtorEmail = res.data.debtor_email;
            this.isEmail = true;
            this.emailItems.push({
              type: 'debtor_email',
              id: this.debtorId,
              email: res.data.debtor_email,
              sendEmail: 1,
            });
          }
          if (res.data.debtor_phone) {
            this.isSMS = true;
            this.phoneItems.push({
              type: 'debtor_phone',
              id: res.data.debtor_id,
              number: res.data.debtor_phone,
              isActive: 1,
            });
          }
          if (res.data.debtor_mobile) {
            this.isSMS = true;
            this.phoneItems.push({
              type: 'debtor_mobile',
              id: res.data.debtor_id,
              number: res.data.debtor_mobile,
              isActive: 1,
            });
          }
        }
      });
  }
  ngOnDestroy(): void {
    if (this.debtorDetailsSubscription) {
      this.debtorDetailsSubscription.unsubscribe();
    }
    if (this.caseDetailsSubscription) {
      this.caseDetailsSubscription.unsubscribe();
    }
  }

  goToContactus() {}

  async openCommunicationPreferences() {
    const modal = await this.modalController.create({
      component: CommunicationPreferencesComponent,
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
  }
}
